import {useRef, useState} from 'react'
import {Button} from '@primer/react'

import {ResolveConflictsDialog} from '../../../common/ResolveConflictsDialog'

/**
 * CTA for the stack conflict scenarios. Stack conflicts must be resolved from the command
 * line, so this opens a dialog with the `gh stack` instructions rather than a web editor.
 */
export function ResolveConflictsButtonAndDialog({stackNumber}: {stackNumber: number}) {
  const [showDialog, setShowDialog] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const closeDialog = () => {
    setShowDialog(false)
    buttonRef.current?.focus()
  }

  return (
    <>
      <Button ref={buttonRef} onClick={() => setShowDialog(true)}>
        Resolve conflicts
      </Button>
      {showDialog && (
        <ResolveConflictsDialog stackNumber={stackNumber} returnFocusRef={buttonRef} onClose={closeDialog} />
      )}
    </>
  )
}
